import { render, staticRenderFns } from "./InvestmentReport.vue?vue&type=template&id=71586ae4&scoped=true&"
import script from "./InvestmentReport.vue?vue&type=script&lang=js&"
export * from "./InvestmentReport.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentReport.vue?vue&type=style&index=0&id=71586ae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71586ae4",
  null
  
)

export default component.exports